export class RegistrationSyncRequest {
    status: string;
    syncCrunJob: string;

    constructor() {
        this.status = '';
        this.syncCrunJob = '';
    }
}